import React from "react"
import { Link } from "gatsby"
import "./main-navigation.module.scss"
import { NavigationLinksOutput } from "../../contexts/settings/Navigation/navigation-types"
import { useLayout } from "contexts/components/LayoutContext"

interface MainNavigationProps {
  navItem: NavigationLinksOutput
  index: number
  navCount: number
}

export const MainNavigation = ({ navItem }: MainNavigationProps) => {
  const { linkedPagesUrlPathCodex } = useLayout()
  const { slug, linkText } = navItem
  const path = linkedPagesUrlPathCodex[slug] || "404"
  const newSlug = path.startsWith("/") ? path : `/${path}`
  return (
    <Link
      to={newSlug}
      className="fr-header__link"
      activeClassName="fr-header__link--current"
    >
      {linkText}
    </Link>
  )
}
